import React from 'react';
import PropTypes from 'prop-types';

const Injured = (
    {
        width = 26,
        height = 26,
    }) =>

    <svg width={width} height={height} viewBox="0 0 347 347" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(10 10)" fill="none" fillRule="evenodd"><circle stroke="#3F53CA" strokeWidth="20" fill="#FFF" cx="163.5" cy="163.5" r="163.5"/><path fill="#E10000" d="M124.847 47.916l-.458 77.39-77.39-.46v78.307h77.847l.458 77.39 77.848-.46v-76.93l77.847-.458v-77.848h-76.932L203.61 47"/></g>
    </svg>


Injured.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
}

export default Injured



// WEBPACK FOOTER //
// ./src/components/Icon/svg/injured.js